"use client";
import { useEffect } from "react";
import { Icon } from "../icons";
import { useWorkspace } from "../workspace";

export function WorkspaceToast() {
  const { notice, notify, l } = useWorkspace();
  useEffect(() => {
    if (!notice) return;
    const timer = setTimeout(() => notify(null), 4500);
    return () => clearTimeout(timer);
  }, [notice, notify]);
  return (
    <>
      {notice && (
        <div
          className="toast fixed bottom-6 left-[calc(50%_+_100px)] -translate-x-1/2 bg-ink text-white py-3.25 px-4.75 rounded-[10px] shadow-[0_8px_30px_#0f1b2d30] flex items-center gap-2.5 text-[12px] z-100 max-w-[calc(100vw_-_35px)] [&_.icon]:text-[#7bdfbd] [&_.icon]:w-4 [&_.icon]:h-4 max-[1000px]:left-[calc(50%_+_110px)] max-[760px]:left-[50%]"
          role="status"
        >
          <Icon name="check" />
          {l(notice)}
        </div>
      )}
    </>
  );
}
